module.exports = __webpack_public_path__ + "media/images/icons/button-icons-6b68d0140f43b8408b638f521148a82d.png";